import { render, staticRenderFns } from "./VacunaNew.vue?vue&type=template&id=83ead644"
import script from "./VacunaNew.vue?vue&type=script&lang=js"
export * from "./VacunaNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports